import { useCallback, useState } from 'react';
import { copyText } from '@/lib/mailto';
import { Icon } from './Icon';

/** 邮箱地址这类需要被抄走的内容：等宽显示 + 一键复制。 */
export function CopyField({
  label,
  value,
  href,
  className,
}: {
  label?: string;
  value: string;
  href?: string;
  className?: string;
}) {
  const [copied, setCopied] = useState(false);

  const handleCopy = useCallback(async () => {
    const ok = await copyText(value);
    setCopied(ok);
    if (ok) window.setTimeout(() => setCopied(false), 2200);
  }, [value]);

  return (
    <div className={['flex flex-col gap-1.5', className].filter(Boolean).join(' ')}>
      {label ? <span className="label-mono">{label}</span> : null}
      <div className="flex items-center gap-2 rounded-xl border border-line bg-surface-1 p-1.5 pl-3.5">
        {href ? (
          <a href={href} className="metric-value min-w-0 flex-1 truncate text-sm text-fg hover:underline">
            {value}
          </a>
        ) : (
          <span className="metric-value min-w-0 flex-1 truncate text-sm text-fg">{value}</span>
        )}
        <button
          type="button"
          onClick={handleCopy}
          aria-label={copied ? '已复制' : `复制 ${value}`}
          className="inline-flex shrink-0 items-center gap-1.5 rounded-lg px-2.5 py-1.5 text-xs font-medium text-fg-muted transition-colors hover:bg-surface-2 hover:text-fg"
        >
          <Icon name={copied ? 'check' : 'copy'} size={14} />
          {copied ? '已复制' : '复制'}
        </button>
      </div>
    </div>
  );
}
